import { render } from "./PageViews.vue?vue&type=template&id=fb76b346"
import script from "./PageViews.vue?vue&type=script&lang=js"
export * from "./PageViews.vue?vue&type=script&lang=js"

import "./PageViews.vue?vue&type=style&index=0&id=fb76b346&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__